/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the NewUAApplicationCreationDetails
 *
 * @class NewUAApplicationCreationDetails
 */
class NewUAApplicationCreationDetails {
  /**
   * Creates an instance of NewUAApplicationCreationDetails.
   * @param {*} json
   * @memberof NewUAApplicationCreationDetails
   */
  constructor(json = null) {
    if (json) {
      // string
      this.application_form_id = json.application_form_id;

      // string
      this.submission_form_id = json.submission_form_id;
    }
  }
}

/**
 * Models the NewUAIntakeApplicationIdentifierResponse
 *
 * @class NewUAIntakeApplicationIdentifierResponse
 */
class NewUAIntakeApplicationIdentifierResponse {
  /**
   * Creates an instance of NewUAIntakeApplicationIdentifierResponse.
   * @param {*} json
   * @memberof NewUAIntakeApplicationIdentifierResponse
   */
  constructor(json = null) {
    if (json) {
      // string
      this.application_id = json.application_id;

      // string
      this.applicationReference = json.applicationReference;
    }
  }
}

export default {
  NewUAApplicationCreationDetails,

  NewUAIntakeApplicationIdentifierResponse,
};
